//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// week-in-review-not-available imports
import { IContainer, IProps, IState } from "./WeekInReviewNotAvailable.d";
import { weekInReviewNotAvailableFragments } from "./WeekInReviewNotAvailable.gql";
import * as s from "./WeekInReviewNotAvailable.styles";
// state
import { IReduxState } from "@reducers/root.reducer";
import { updateOrgInvite } from "@mutations";
import { snackBarOpen } from "@actions/snack-bar.actions";
// util
import { weekInReviewGif } from "@img/illustrations/";
import { A } from "@ui";
import { TrackingEvents, track } from "@util/analytics.util";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class WeekInReviewNotAvailableCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private onInviteSuccess = () => {
    this.props.snackBarOpen("Invite sent! Check back after they've signed up.");
  };

  private onInviteFailure = () => {
    this.props.snackBarOpen("Sorry, there was a problem sending the invitation.");
  };

  private handleInvite = () => {
    const { relay, org, person } = this.props;

    if (!person || !person.primaryEmail) {
      this.onInviteFailure();
      return;
    }

    const calendarIds = [person.primaryEmail];
    track(TrackingEvents.WEEK_IN_REVIEW.SEND_INVITE, {
      calendarId: person.primaryEmail,
    });
    updateOrgInvite(
      relay.environment,
      { calendarIds, orgRelayId: org.id },
      this.onInviteSuccess,
      this.onInviteFailure,
    );
  };

  public render() {
    const { person, statusCode } = this.props;

    let view: "Error" | "Invite" | "NotReady" = "NotReady";
    let name = "";
    if (!person || statusCode !== 404) {
      view = "Error";
    } else if (person && !person.isUser) {
      view = "Invite";
      name = person.primaryEmail;
      if (person.profile && person.profile.givenName) {
        name = person.profile.givenName;
      }
    }

    return (
      <div className={this.props.classes.container}>
        <div style={s.caption}>
          {view === "Error" ? (
            <div>
              Sorry, an error occurred.
              <br />
              Please try again later.
            </div>
          ) : (
            ""
          )}
          {view === "Invite" ? (
            <div>
              <A onClick={() => this.handleInvite()}>Invite {name}</A> to see their week in review.
            </div>
          ) : (
            ""
          )}
          {view === "NotReady" ? (
            <div>
              This week in review is not yet ready.
              <br />
              Please check back later.
            </div>
          ) : (
            ""
          )}
        </div>

        {view === "Invite" ? (
          <div>
            <div style={s.sample}>sample</div>
            <img src={weekInReviewGif} style={s.gif} />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const WeekInReviewNotAvailableStyled = withStyles(s)(WeekInReviewNotAvailableCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const WeekInReviewNotAvailableRedux = connect(mapStateToProps, {
  snackBarOpen,
})(WeekInReviewNotAvailableStyled);

//////////////////
// RELAY
//////////////////
export const WeekInReviewNotAvailable = createFragmentContainer<IContainer>(
  WeekInReviewNotAvailableRedux,
  weekInReviewNotAvailableFragments,
);
